var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-hide shadow-1", attrs: { color: "white" } },
    [
      _c("div", { staticClass: "row q-py-md q-px-md fit justify-center" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-2" }, [
              _c("img", {
                staticStyle: { "max-width": "100%" },
                attrs: { src: _vm.logo, height: "auto" }
              })
            ]),
            _c(
              "div",
              { staticClass: "col-10 text-right self-center" },
              _vm._l(_vm.getNavbarOrder, function(button, index) {
                return _c(
                  "span",
                  { key: index },
                  [
                    button.to
                      ? _c("q-btn", {
                          attrs: {
                            flat: "",
                            size: "lg",
                            color:
                              button.to == _vm.$route.meta.title
                                ? "primary"
                                : "secondary",
                            label: _vm.$t(button.text)
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({ name: button.to })
                            }
                          }
                        })
                      : _vm._e(),
                    !button.to && button.buttons.length > 0
                      ? _c(
                          "q-btn-dropdown",
                          {
                            attrs: {
                              flat: "",
                              size: "lg",
                              label: button.text,
                              color: _vm.getColorButtonMerged
                            }
                          },
                          [
                            _c(
                              "q-list",
                              _vm._l(button.buttons, function(b, index) {
                                return _c(
                                  "q-item",
                                  {
                                    key: "b-" + index,
                                    attrs: { link: "", to: { name: b.to } }
                                  },
                                  [
                                    _c(
                                      "q-item-main",
                                      [
                                        _c(
                                          "q-item-tile",
                                          { attrs: { label: "" } },
                                          [_vm._v(_vm._s(_vm.$t(b.text)))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }